'use client';
import Cookies from 'js-cookie';
import { useEffect } from 'react';
import { loadUser } from 'redux/actions/authActions';
import store from 'redux/store';

export default function RestoreAuth() {
    useEffect(() => {
        const token = Cookies.get('token');
        const state = store.getState();

        if (!state.auth.isAuthenticated && token) {
            console.log('App Router: Restoring user session...');
            (store.dispatch as any)(loadUser());
        }
    }, []);
    return null;
}
